import api from '@/services/index.js'
async function checkPhoneNumber(PhoneNumber, callback) {
  api
    .post('/auth-service/v1/checkPhone', {
      phoneNumber: PhoneNumber,
    })
    .then((v) => {
      if (v.success == true) {
        callback({
          status: true,
          data: v.data,
          message: '',
        })
      } else {
        callback({ status: false, data: '', message: v.message })
      }
    })
    .catch((e) => {
      callback({ status: false, data: '', message: e.message })
    })
}

async function checkBankNumber(BankNumber, BankCode, callback) {
  await api
    .post('/auth-service/v1/checkBank', {
      BankAccount: BankNumber,
      BankCode: BankCode,
    })
    .then((v) => {
      if (v.success == true) {
        callback({
          status: true,
          data: v.data,
          message: '',
        })

        // this.ReqStep = 3
        // this.setError(null)
      } else {
        callback({ status: false, data: '', message: v.message })
      }
    })
    .catch((e) => {
      callback({ status: false, data: '', message: e.message })
    })
}
async function changePassword(data, callback) {
  if (
    data.old_Password == '' ||
    data.new_password == '' ||
    data.confirm_password == ''
  ) {
    callback({ status: false, data: '', message: 'กรุณากรอกข้อมูลให้ครบ' })
  } else {
    await api
      .put('/auth-service/v1/change-password', {
        phone_number: data.PhoneNumber,
        old_Password: data.old_Password,
        Password: data.new_password,
        Confirm_Password: data.confirm_password,
      })
      .then((v) => {
        if (v.success == false) {
          callback({
            status: true,
            data: 'แจ้งเตือน',
            message: 'เปลี่ยนรหัสผ่านเรียบร้อยแล้ว',
          })
        } else {
          callback({
            status: false,
            data: '',
            message: v.message,
          })
        }
      })
      .catch((e) => {
        callback({ status: false, data: '', message: e.message })
      })
      .finally(() => {})
  }
}
export { changePassword, checkPhoneNumber, checkBankNumber }



// WEBPACK FOOTER //
// ./src/services/modules/user.js